import OrdersLocationInfo from "./OrdersLocationInfo";
export default OrdersLocationInfo